import { GrapevineCommentApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineCommentApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new GrapevineCommentApi(configuration), [configuration]);
};
